import { FolderKanban, Workflow, BrainCircuit, Users, BookOpen, Code2 } from "lucide-react";

// Proyectos enriquecidos (rediseño 2026-07-02): descripción + stats + tareas/actividad mock.
export const projects = [
  {
    id: "p1",
    name: "Automatizaciones n8n",
    description: "Recursos, tutoriales y plantillas para automatizar procesos con n8n.",
    icon: Workflow,
    iconCls: "bg-teal-700 text-white",
    itemIds: ["c1", "e3", "e9"],
    itemCount: 3,
    taskCount: 6,
    ideaCount: 2,
    updated: "hace 1 h",
    estado: "activo",
    starred: true,
  },
  {
    id: "p2",
    name: "Rediseño del dashboard",
    description: "Inspiración, patrones y decisiones de UI para el nuevo panel.",
    icon: BookOpen,
    iconCls: "bg-orange-700 text-white",
    itemIds: ["c2", "e7", "e11", "e16"],
    itemCount: 4,
    taskCount: 3,
    ideaCount: 4,
    updated: "ayer",
    estado: "activo",
  },
  {
    id: "p3",
    name: "Formación RAG / IA",
    description: "Todo lo relacionado con Retrieval Augmented Generation y asistentes con IA.",
    icon: BrainCircuit,
    iconCls: "bg-violet-700 text-white",
    itemIds: ["c3", "e8", "e14"],
    itemCount: 3,
    taskCount: 4,
    ideaCount: 1,
    updated: "hace 3 h",
    estado: "activo",
    tasks: [
      { id: "pt1", title: "Probar pgvector con datos reales", due: "23 may" },
      { id: "pt2", title: "Grabar vídeo: RAG en 15 minutos", due: "26 may" },
    ],
  },
  {
    id: "p4",
    name: "Landing de Aviando",
    description: "Copy, ganchos y referencias para la página de captación.",
    icon: Code2,
    iconCls: "bg-stone-700 text-white",
    itemIds: ["c6", "e18"],
    itemCount: 2,
    taskCount: 2,
    ideaCount: 1,
    updated: "hace 2 días",
    estado: "en-pausa",
    tasks: [
      { id: "pt3", title: "Escribir el hero con el gancho del dolor", due: "21 may" },
      { id: "pt4", title: "Validar mensajes con 3 personas", due: "24 may" },
    ],
  },
  {
    id: "p5",
    name: "Clientes",
    description: "Proyectos con clientes, entregables y comunicación organizada.",
    icon: Users,
    iconCls: "bg-stone-500 text-white",
    itemIds: ["c4", "e17"],
    itemCount: 2,
    taskCount: 5,
    ideaCount: 2,
    updated: "hace 1 día",
    estado: "archivado",
  },
];

export const DEFAULT_PROJECT_ICON = FolderKanban;
